export default "__VITE_ASSET__CS4fGRGP__"